import React from 'react';
import { Users, UserCheck, UserX, Clock, ArrowUp, ArrowDown } from 'lucide-react';
import { Card } from '@/components/ui/card';
import { cn } from '@/lib/utils';

const StatCard = ({ title, value, icon: Icon, color, change, changeType, isLoading }) => {
  if (isLoading) {
    return (
      <Card className="p-6 w-64 flex-shrink-0 lg:w-auto">
        <div className="animate-pulse space-y-3">
          <div className="h-4 bg-muted rounded w-1/2"></div>
          <div className="h-8 bg-muted rounded w-3/4"></div>
        </div>
      </Card>
    );
  }

  return (
    <Card className="p-6 hover:border-secondary transition-colors w-64 flex-shrink-0 lg:w-auto">
      <div className="flex justify-between items-start mb-2 min-h-[20px]">
        <p className="text-sm text-muted-foreground flex-1">{title}</p>
        <div className="flex-shrink-0">
          <Icon className={`h-4 w-4 ${color}`} />
        </div>
      </div>
      <p className="text-3xl lg:text-4xl font-bold text-foreground mb-1">{value}</p>
      {change && (
        <div className={cn("flex items-center text-sm", changeType === 'positive' ? 'text-green-500' : 'text-red-500')}>
          {changeType === 'positive' ? <ArrowUp className="w-4 h-4 mr-1" /> : <ArrowDown className="w-4 h-4 mr-1" />}
          <span>{change}</span>
        </div>
      )}
    </Card>
  );
};

const UserStats = ({ statistics, isLoading }) => {
  // Calculate changes (simulated for now - replace with real data from API)
  const totalUsers = statistics?.total_users || 0;
  const activeUsers = statistics?.active_users || 0;
  const inactiveUsers = statistics?.inactive_users || 0;
  const pendingUsers = statistics?.by_status?.PENDING || 0;

  const stats = [
    {
      title: 'Total utilisateurs',
      value: totalUsers,
      icon: Users,
      color: 'text-blue-500',
      change: '+5% vs mois',
      changeType: 'positive',
    },
    {
      title: 'Utilisateurs actifs',
      value: activeUsers,
      icon: UserCheck,
      color: 'text-green-500',
      change: '+8% vs mois',
      changeType: 'positive',
    },
    {
      title: 'Utilisateurs inactifs',
      value: inactiveUsers,
      icon: UserX,
      color: 'text-red-500',
      change: '-12% vs mois',
      changeType: 'positive',
    },
    {
      title: 'En attente',
      value: pendingUsers,
      icon: Clock,
      color: 'text-yellow-500',
      change: '-3% vs hier',
      changeType: 'positive',
    },
  ];

  return (
    <div className="lg:grid lg:grid-cols-4 lg:gap-6">
      <div className="flex space-x-6 overflow-x-auto pb-4 -mx-4 px-4 lg:contents" style={{ scrollbarWidth: 'none', WebkitOverflowScrolling: 'touch' }}>
        {stats.map((stat, index) => (
          <StatCard key={index} {...stat} isLoading={isLoading} />
        ))}
      </div>
    </div>
  );
};

export default UserStats;

